const getFileExtension = (fileUri) => {
	if (!fileUri) return null;
	return fileUri.slice(((fileUri.lastIndexOf('.') - 1) >>> 0) + 2);
};

export default getFileExtension;
